import React, { Component } from 'react';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';
//styles
import 'bootstrap/dist/css/bootstrap.css';
import './products.styl';
//text
import { contactText, contactCategories } from '../input-text/en/contact_page';

class Contact extends Component {

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-md-4 hidden-xs header-image-container'>
            <i className="fa fa-envelope-open-o fa-5x developers-icon" aria-hidden="true"></i>
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{contactText._1}</h1>
            <p>{contactText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ contactCategories._1 } />
        <CategoryContainer cols='1' category={ contactCategories._2 } />
        <CategoryContainer cols='1' category={ contactCategories._3 } />
      </div>
    );
  }
};

export default Contact;



// WEBPACK FOOTER //
// ./src/routes/Contact.js